import PostPublishDomainSetupModal from 'ContentComponents/components/modals/PostPublishDomainSetupModal';
import { useDispatch, useSelector } from 'react-redux';
import { getPostPublishDomainSetupModalOpen } from '../../redux/selectors/modalSelectors';
// @ts-expect-error Untyped module
import { togglePostPublishDomainSetupModal } from '../../redux/actions/appActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const PostPublishDomainSetupMessageModal = ({
  publishedContentUrl
}) => {
  const dispatch = useDispatch();
  const modalOpen = useSelector(getPostPublishDomainSetupModalOpen);
  if (modalOpen) {
    return /*#__PURE__*/_jsx(PostPublishDomainSetupModal, {
      closeModal: () => dispatch(togglePostPublishDomainSetupModal(false)),
      publishedContentUrl: publishedContentUrl,
      usageTracker: UsageTracker
    });
  }
  return null;
};
export default PostPublishDomainSetupMessageModal;